export default __webpack_public_path__ + "static/media/ksivalue_big@2x.5e8e7c54.jpg";